import request from '@/router/axios';
export const add = (row) => {
return request({
url: '/api/produce/produce-team/insert',
method: 'post',
data: row
})
}
export const update = (row) => {
return request({
url: '/api/produce/produce-team/update',
method: 'post',
data: row
})
}
export const getDetail = (id) => {
return request({
url: '/api/produce/produce-team/select/id',
method: 'get',
params: {
id
}
})
}
export const getList = (params) => {
return request({
url: '/api/produce/produce-team/select/page',
method: 'get',
params
})
}
export const remove = (ids) => {
return request({
url: '/api/produce/produce-team/delete/ids',
method: 'get',
params: {
ids
}
})
}

export const userSelect = (ids) => {
  return request({
      url: 'api/produce/blade-user/select/userList',
    method: 'get',
    params: {}
  })
}



// 获取组员列表
export const getMemberList = (params) => {
  return request({
    url: "api/produce/base-workorderuser/select/page",
    method: "post",
    params: {
      ...params,
      current:params.page,
      size:params.size,
    },
  });
};
